import React from "react";
import { detailLabelStyle, detailValueStyle } from "./supplierManagementStyles";

export const DetailRow = ({ label, value }) => (
  <div style={{ minWidth: 0 }}>
    <div style={detailLabelStyle}>{label}</div>
    <div style={detailValueStyle}>{value ?? "—"}</div>
  </div>
);

export const PercentBarList = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return <div style={{ fontSize: 13, color: "var(--ink-4)" }}>—</div>;
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {items.map((item, idx) => {
        const pct = Number(item?.percentage ?? 0);
        return (
          <div key={`${item?.name ?? "item"}-${idx}`}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--ink-2)",
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              <span>{item?.name ?? "—"}</span>
              <span style={{ fontFamily: "var(--font-mono)", color: "var(--ink-3)" }}>
                {Number.isFinite(pct) ? `${pct}%` : "—"}
              </span>
            </div>
            <div
              style={{
                height: 6,
                background: "#e9edf2",
                borderRadius: 999,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${Math.max(0, Math.min(100, pct))}%`,
                  height: "100%",
                  background: "var(--accent, #2563eb)",
                  borderRadius: 999,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const CountTriple = ({ label, value }) => (
  <div
    style={{
      flex: 1,
      minWidth: 0,
      textAlign: "center",
      padding: "8px 6px",
      border: "1px solid var(--rule)",
      borderRadius: 8,
      background: "var(--surface)",
    }}
  >
    <div
      style={{
        fontSize: 18,
        fontWeight: 800,
        color: "var(--ink)",
        fontFamily: "var(--font-mono)",
      }}
    >
      {value ?? 0}
    </div>
    <div style={{ ...detailLabelStyle, marginBottom: 0, marginTop: 2 }}>
      {label}
    </div>
  </div>
);

export const LabelledInput = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  disabled,
}) => (
  <div style={{ minWidth: 0 }}>
    <div style={detailLabelStyle}>{label}</div>
    <input
      className="kpi-input"
      type={type}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      style={{ width: "100%" }}
    />
  </div>
);

export const LabelledSelect = ({ label, value, onChange, children, disabled }) => (
  <div style={{ minWidth: 0 }}>
    <div style={detailLabelStyle}>{label}</div>
    <select
      className="kpi-input"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{ width: "100%" }}
    >
      {children}
    </select>
  </div>
);
